import React, { useState } from "react";
import Hero from "./components/Hero";
import HotOffers from "./components/HotOffers";
import FeaturedProperties from "./components/FeaturedProperties";
import PropertyCategories from "../../components/Shared/PropertyCategories";
import ContactUsModal from "../../components/Modals/ContactUsModal";
import About from "./components/About";
import AddUnitModal from "../../components/Modals/AddUnitModal";
import Header from "../../components/Header/Header";
import Blogs from "./components/Blogs";

const HomePage = ({ pageData }) => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showAddUnitModal, setShowAddUnitModal] = useState(false);
  const openContactModal = () => setShowContactModal(true);
  const openAddUnitModal = () => setShowAddUnitModal(true);
  return (
    <>
      {/* <Header blur={true} pageData={pageData} /> */}

      <Hero
        pageData={pageData}
        openContactModal={openContactModal}
        openAddUnitModal={openAddUnitModal}
      />

      <HotOffers
        hotOffers={pageData.hot_deals}
        projects={pageData.featured_properties}
        Property_categories={pageData.property_categories}
      />
      <FeaturedProperties
        featuredProperties={pageData.featured_properties}
        projects={pageData.featured_properties}
      />
      <PropertyCategories 
        luxury_properties={pageData.luxury_properties}
      />
      <Blogs blogs={pageData.blogs} />
      <About />

      {/* Modals */}
      <ContactUsModal
        show={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
      <AddUnitModal
        isOpen={showAddUnitModal}
        onClose={() => setShowAddUnitModal(false)}
        pageData={pageData}
      />
    </>
  );
};

export default HomePage;
